import { createFileRoute } from "@tanstack/react-router";
import { optionalString } from "@/lib/search";
import { PortalHeader } from "@/components/app/patterns/portal-frame";
import { PortalNotice } from "@/components/app/patterns/portal-notice";
import { FileText } from "@/lib/public-icons";
import { SigningScreen } from "../sign/-components/signing-screen";

export const Route = createFileRoute("/signing/$envelopeId")({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: optionalString(search.token),
  }),
  component: LegacySigningLink,
});

/** Legacy `/signing/:envelopeId?token=…`, kept because those links are in inboxes. The token, not
 * the envelope id, is the authorization, so it goes to the `/sign/:token` screen and the server
 * checks the pair. */
function LegacySigningLink() {
  const { token } = Route.useSearch();

  if (!token) {
    return (
      <div className="flex min-h-dvh flex-col">
        <PortalHeader title="Document to sign" />
        <main className="flex-1 px-4 py-6 sm:py-8">
          <PortalNotice icon={<FileText />} tone="warn" title="This signing link is incomplete">
            It is missing the part that identifies you, which usually means it was copied without
            the whole address. Open it from the original message, or ask whoever sent it for a fresh
            link.
          </PortalNotice>
        </main>
      </div>
    );
  }

  return <SigningScreen token={token} />;
}
